import React from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";
import { Link } from 'react-router-dom';
import { motion } from "framer-motion";

// Remove the CSS import
// import './SpanishFees.css';

// --- Embedded CSS ---
// I've moved the styles from the .css file right into this component.
// This bypasses the import error you were seeing.
const styles = `
  .fees-section {
    background: linear-gradient(to bottom, #f0fdfa, #f0f9ff);
    padding-top: 4rem;
    padding-bottom: 4rem;
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .fees-title {
    font-size: 1.875rem; /* 30px */
    line-height: 2.25rem; /* 36px */
    font-weight: 700;
    text-align: center;
    margin-bottom: 3rem; /* 48px */
    color: rgb(31 41 55);
  }

  .fees-card {
    width: 100%;
    max-width: 28rem; /* 448px */
    margin-left: auto;
    margin-right: auto;
    background-color: #ffffff;
    border-radius: 1.5rem; /* 24px */
    box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    padding: 1.5rem; /* 24px */
  }

  .fees-card > div {
    margin-bottom: 2rem; /* 32px */
  }
  .fees-card > div:last-child {
    margin-bottom: 0;
  }

  @media (min-width: 768px) {
    .fees-card {
      padding: 2rem; /* 32px */
    }
  }

  .fees-card-header {
    text-align: center;
    background-color: #81e6d9;
    border-radius: 9999px;
    padding-left: 1.5rem; /* 24px */
    padding-right: 1.5rem; /* 24px */
    padding-top: 0.75rem; /* 12px */
    padding-bottom: 0.75rem; /* 12px */
    margin-bottom: 1rem; /* 16px */
  }

  .fees-card-header-title {
    font-size: 1.125rem; /* 18px */
    line-height: 1.75rem; /* 28px */
    font-weight: 600;
    color: #234e52;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  .fees-card-header-subtitle {
    font-size: 0.875rem; /* 14px */
    line-height: 1.25rem; /* 20px */
    color: #285e61;
  }

  .fees-rows-container > .fee-row:not(:first-child) {
    border-top-width: 1px;
    border-color: #e5e7eb;
  }

  .fee-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 1.5rem; /* 24px */
    padding-right: 1.5rem; /* 24px */
    padding-top: 1rem; /* 16px */
    padding-bottom: 1rem; /* 16px */
  }

  .fee-row-duration {
    color: #4b5563;
  }

  .fee-row-price {
    font-weight: 600;
    color: #111827;
  }

  .fees-card-footer {
    text-align: center;
    font-size: 0.875rem; /* 14px */
    line-height: 1.25rem; /* 20px */
    font-weight: 600;
    color: #4b5563;
    font-style: italic;
  }

  .fees-bottom-text {
    text-align: center;
    max-width: 42rem; /* 672px */
    margin-left: auto;
    margin-right: auto;
    margin-top: 3rem; /* 48px */
  }

  .fees-bottom-text p {
    font-size: 1.125rem; /* 18px */
    line-height: 1.75rem; /* 28px */
    color: #4b5563;
    margin-bottom: 0.75rem; /* 12px */
  }

  .fees-bottom-text p:last-child {
    margin-bottom: 0;
  }

  .fees-bottom-highlight {
    font-weight: 600;
  }
`;
// --- End of Embedded CSS ---


// Helper component for table rows
const FeeRow = ({ duration, price }) => (
  <div className="fee-row">
    <span className="fee-row-duration">{duration}</span>
    <span className="fee-row-price">${price}</span>
  </div>
);

// Data for the tables
const privateClasses = [
  { duration: "1 hour", price: 17 },
  { duration: "10 hours", price: 150 },
  { duration: "20 hours", price: 270 },
  { duration: "40 hours", price: 500 },
  { duration: "60 hours", price: 690 },
  { duration: "80 hours", price: 880 },
];

const onlineClasses = [
  { duration: "1 hour", price: 12 },
];

function SpanishFees() {
  return (
    <section className="">
      {/* This <style> tag will apply all the CSS within this component.
        This is a common workaround for environments where CSS imports fail.
      */}
      <style>{styles}</style>

      <div className="home-container">
        {/* Dark overlay */}
        <div className="overlay"></div>

        {/* Content */}
        <div className="home-content">
          <h1>Our Spanish Lessons Fees</h1>
          <p>"Don't limit your challenges, challenge your limits."</p>
          <br></br>
        </div>
      </div>

      <section className="about-linguahub">
        <h2>Our Fees</h2>
        <p>
          Our classes are planned to meet your learning needs. Your class can start any Monday in the year. Just let us know when you want to start 2 weeks prior your Spanish Immersion, in order to plan teachers' schedules and class materials.
        </p>
        <p>Features of Culturlingua Tlaquepaque’s Pricing structure.
        </p>
        <p>We do not charge registration fees.</p>
      </section>

      <section className="certifications">
        <div className="certifications-container">
          <motion.div
            className="certification-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <img src="./assets/fees1.avif" className="certification-image" alt="Face-to-face or online lesson" />
            <br></br><br></br>
            <h3>Face-To-Face or Online Sessions</h3>
            <p>You can choose between online classes or study at our school</p>
          </motion.div>
          <motion.div
            className="certification-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <img src="./assets/fees2.avif" className="certification-image" alt="Class schedule" />
            <br></br><br></br>
            <h3>5 days a week</h3>
            <p>The classes have a duration of 4 hours per day normally, 5 days a week but we are adaptable to your necessities.</p>
          </motion.div>
          <motion.div
            className="certification-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <img src="./assets/fees3.avif" className="certification-image" alt="Materials included" />
            <br></br><br></br>
            <h3>Materials Included</h3>
            <p>All the material is included, just bring a notebook and a pen.</p>
          </motion.div>
        </div>
      </section>

      {/* --- MODIFIED FEES SECTION (now with embedded CSS) --- */}
      <section className="fees-section">
        <h2 className="fees-title">Fees Schedule 2026</h2>
        
        <div className="fees-card">
          
          {/* Table 1: Private Classes */}
          <div>
            <div className="fees-card-header">
              <h3 className="fees-card-header-title">Private Classes</h3>
              <p className="fees-card-header-subtitle">Tutoring Packages</p>
            </div>
            <div className="fees-rows-container">
              {privateClasses.map((item, index) => (
                <FeeRow key={`private-${index}`} duration={item.duration} price={item.price} />
              ))}
            </div>
          </div>

          {/* Table 2: Online Private Lessons */}
          <div>
            <div className="fees-card-header">
              <h3 className="fees-card-header-title">Online Private Lessons</h3>
              <p className="fees-card-header-subtitle">Online Tutoring Packages</p>
            </div>
            <div className="fees-rows-container">
              {onlineClasses.map((item, index) => (
                <FeeRow key={`online-${index}`} duration={item.duration} price={item.price} />
              ))}
            </div>
          </div>

          {/* Footer Note */}
          <p className="fees-card-footer">*PRICES IN $ US</p>
        </div>

        <div className="fees-bottom-text">
          <p>We gladly accept payment in Pesos, Dollars, Travelers checks, PayPal or Credit cards.</p>
          <p className="fees-bottom-highlight">*** We will gladly pick you up from the airport and take you direct to your accommodation for a charge of $20 USD ***</p>
        </div>
      </section>
      {/* --- END OF MODIFIED SECTION --- */}


      {/* More Information Section */}
      <section className="more-info-section">
        <h2>More Info</h2>
        <div className="info-links">
          <Link to="/Placement-Test">📚 Placement Test</Link>
          <Link to="/spanish">✍️ Lessons</Link>
          <Link to="/contacto">📩 Contact Us</Link>
        </div>
        <br></br>
      </section>
    </section>
  );
}

export default SpanishFees;